import type {
  ApolloClient,
  MaybeMasked,
  MutationOptions,
  NormalizedCacheObject,
  OperationVariables,
  QueryOptions
} from '@apollo/client';
import { mapResult } from '~/api/data/result';

/** Execute a query without making route or navigation decisions. */
export const queryData = async <Q, V extends OperationVariables, R>(
  client: ApolloClient<NormalizedCacheObject>,
  options: QueryOptions<V, Q>,
  select: (data: MaybeMasked<Q> | null | undefined) => R | null | undefined
) => mapResult(await client.query<Q, V>(options), select);

/** Preserve the payload and GraphQL errors for the caller to handle. */
export const mutateData = async <Q, V extends OperationVariables>(
  client: ApolloClient<NormalizedCacheObject>,
  options: MutationOptions<Q, V>
) => mapResult(await client.mutate<Q, V>(options), (data) => data);
